import styled from 'styled-components'

export const InlineWrapper = styled.div`
	max-width: 300px;
	display: flex;
	justify-content: space-between;
`

export const FormField = styled.div`
	margin-bottom: ${({ theme }) => theme.formIdent};
`
